import { BUSCAR_PRECOS, LIMPAR_PRECOS } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarRotas (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_PRECOS: {
      const preco = action.payload.precoPaginacao;

      if (preco) {
        return preco
      }
      return []
    }
    case LIMPAR_PRECOS:
      return []

    default: {
      return state
    }
  }
}
